import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Fall from '../../component/Fall/Main_Fall';
import CallInfo from '../../component/CallInfo';
import ParentInfo from '../../component/Info/ParentInfo';

const LiMingYue = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "배성룡 ❤️ 이명월 결혼합니다.";
    const openDesc = "10월 5일 오전 10시";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/281/thumb.jpg";
    
    const parents = [
        {groom : "배기홍 · 김순화(서윤)의 장남"},
        {bride : "이학철 · 이태순의 장녀"}
    ] 

    const lng = 126.904586710033;
    const lat = 37.5213571324809;

    const placeTelNum = "02 6418 3000";

    // const forBus = "[대림호수공원아파트 하차] 77, 98, 99-1\n[동남레이크빌 하차] 77, 98, 99-1, 314, 3100, 3101"
    const forSubway = "👉🏻 5호선 영등포시장역 하차 4번 출구에서 127m미터\n👉🏻 1호선 '영등포역' 하차 영등포 뉴타운 지하상가 4번출구   (새길병원방면)";
    const forCar = "👉🏻 '서울 영등포구 영중로 55' 또는 '서울 영등포구 \n  영등포동6가 7' 입력 \n🅿️ 주차장 안내 - 건물 주차장 영남 주차장"
    const forBus = "- 영등포시장 하차 간선버스(파랑) \n- 605, 661, 761번 지선버스(초록) \n- 5616, 5714, 6514번 광역버스(빨강) \n- 9707, M7646번 공항버스 \n- 6007번 직행버스 - 1082, 1500, 8000, 9030, 9030 \n- 1번 좌석버스 \n- 700, 830, 870, 871번  \n- 5, 60, 60-3, 88번 일반버스";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // #274C01
    const conceptStyle = {
        concept: "FALL",
        titleColor: "#000000",
        pointColor: "#274C01",
        btnBgColor: "#274C01",
        fontColor: "#000000",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }

    const title = "저희 결혼합니다."

    const msg1 = "사랑은 소유가 아니라 \n동행임을 아는 두 사람은";
    const msg2 = "잡은 손을 놓지 않되\n함부로 잡아끌지 않을 것이며 "
    const msg3 = "서로의 두 눈을 고요히 바라보아\n말하지 않아도 같은 쪽으로 걸어가리라 ";
    const msg4 = " - 박미라 , \"아름다운 날에 부치다 \" 중에서 \n\n\n\n저희 두 사람 이제 믿음과 시랑으로 \n한 길을 가려 합니다.\n\n그 시작의 한 걸음, 함께 축복해 주시면 \n감사하겠습니다.\n\n";


    const groomAccountList = [
        {
            role: "신랑",
            name: "PEI CHENGLONG",
            bank: "우리은행",
            accountNumber : "1002-359-194780",
            isKakao : false
        }
        ,{
            role: "신랑 아버지",
            name: "PEI JIHONG",
            bank: "우리은행",
            accountNumber : "1002-651-959797",
            isKakao : false
        }
        , {
            role: "신랑 어머니",
            name: "김서윤",
            bank: "우리은행",
            accountNumber : "1002-649-332-329",
            isKakao : false
        }
    ]


    const brideAccountList = [
        {
            role: "신부",
            name: "LI MINGYUE",
            bank: "농협은행",
            accountNumber : "352-1418-4020-13",
            isKakao : false
        }
        ,{
            role: "신부 아버지",
            name: "LI XUEZHE",
            bank: "기업은행",
            accountNumber : "509-014123-01-018",
            isKakao : false
        }
        ,{
            role: "신부 어머니",
            name: "LI TAISHUN",
            bank: "농협은행",
            accountNumber : "2110-5151-5298-66",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "배성룡",
            call: "010-7666-9007"
        }
        ,{
            role: "신랑 부",
            name: "배기홍",
            call: "010-2270-2643"
        },
        {
            role: "신랑 모",
            name: "김순화 \n(서윤)",
            call: "010-2351-2643"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "이명월",
            call: "010-8372-0700"
        }
        ,{
            role: "신부 부",
            name: "이학철",
            call: "010-5393-7320"
        },
        {
            role: "신부 모",
            name: "이태순",
            call: "010-8120-0304"
        }
    ]

    const parentInfo = {
        groom: {
            dad: { name: "박삼용", isDeceased: false },
            // mom: { name: "", isDeceased: false },
            role: "장남",
        },
        bride: {
            dad: { name: "최명성", isDeceased: false },
            // mom: { name: "", isDeceased: false },
            role: "장녀",
        }
    };


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    const toLowerCaseString = (str) => {
        const parts = str.split(" ");
        if (parts.length < 2) return str; // 성과 이름이 없으면 그대로 반환
        const firstName = parts[1] + (parts[2] || ""); // 이름 부분 결합
        const formattedFirstName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase(); // 이름의 첫 글자만 대문자로 변환
        return `${parts[0]} ${formattedFirstName}`;
    };

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#274C01"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Fall brideNameEn={toLowerCaseString(weddingData.brideNameEn)} groomNameEn={toLowerCaseString(weddingData.groomNameEn)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.pointColor} />
                    <Info_Fall parents={parents} weddingData={weddingData} conceptStyle={conceptStyle} />
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} msg4={msg4} conceptStyle={conceptStyle} />
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    <CallInfo marginTop={"20px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forCar={forCar} forSubway={forSubway} forBus={forBus} conceptStyle={conceptStyle}/>
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default LiMingYue;